'use client';

import {Accordion, styled} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const FaqSectionContainer = styled(StyledSectionContainer, {
  shouldForwardProp: (prop) => prop !== 'embedded',
})<{embedded?: boolean}>(({theme, embedded}) => ({
  color: theme.palette.text.dark,
  marginBottom: theme.spacing(6),
  ...(embedded && {
    '&&': {
      marginBottom: 0,
      paddingBottom: 0,
    },
  }),
}));

export const StyledAccordion = styled(Accordion)(({theme}) => ({
  backgroundColor: theme.palette.background.grey,
  color: theme.palette.text.dark,
  marginBottom: theme.spacing(2),
  '&, &:first-of-type, &:last-of-type': {
    borderRadius: theme.shape.borderRadiusLg,
  },
  '&::before': {
    display: 'none',
  },
}));

export const StyledExpandMoreIcon = styled(ExpandMoreIcon)(({theme}) => ({
  color: theme.palette.text.dark,
}));
